<template>
  <div class="container pro-main" style="background:#FAFAFA;height:auto">
    <h2
      style="text-align:center;font-size:34px;font-weight:600;padding-bottom:.25rem!important"
      class="p-4"
    >
      {{ $t("common.product") }}
    </h2>
    <div class="Titleline"></div>
    <div class="menu-wrapper">
      <md-menu>
        <md-button md-menu-trigger @click="toClassAll">{{
          $t("Product.all")
        }}</md-button>
      </md-menu>
      <md-menu :md-size="menuSize" :md-offset-y="menuOffsetY">
        <md-button md-menu-trigger>{{ $t("Product.Drop1") }}</md-button>

        <md-menu-content>
          <md-menu-item
            ><a href="/promaterial"> <div>产品材料</div></a></md-menu-item
          >
          <md-menu-item
            ><a href="/prostandard"> <div>产品规格</div></a></md-menu-item
          >
          <md-menu-item
            ><a href="/proparams"> <div>产品参数</div></a></md-menu-item
          >
          <md-menu-item
            v-for="(items, sindex) in classifiedPro[1]"
            :key="sindex"
          >
            <div @click="jump(items.productId, items.productName)">
              {{ items.productName }}
            </div>
          </md-menu-item>
        </md-menu-content>
      </md-menu>
      <md-menu>
        <md-button md-menu-trigger>{{ $t("Product.Drop2") }}</md-button>

        <md-menu-content>
          <md-menu-item
            v-for="(items, sindex) in classifiedPro[2]"
            :key="sindex"
          >
            <div @click="jump(items.productId, items.productName)">
              {{ items.productName }}
            </div>
          </md-menu-item>
        </md-menu-content>
      </md-menu>
      <md-menu>
        <md-button md-menu-trigger>{{ $t("Product.Drop3") }}</md-button>

        <md-menu-content>
          <md-menu-item
            v-for="(items, sindex) in classifiedPro[3]"
            :key="sindex"
          >
            <div @click="jump(items.productId, items.productName)">
              {{ items.productName }}
            </div>
          </md-menu-item>
        </md-menu-content>
      </md-menu>
      <md-menu>
        <md-button md-menu-trigger>{{ $t("Product.Drop4") }}</md-button>

        <md-menu-content>
          <md-menu-item
            v-for="(items, sindex) in classifiedPro[4]"
            :key="sindex"
          >
            <div @click="jump(items.productId, items.productName)">
              {{ items.productName }}
            </div>
          </md-menu-item>
        </md-menu-content>
      </md-menu>
    </div>

    <div class="p-2 " :class="{ hideSwiper: ishide }">
      <b-carousel
        id="carousel-fade"
        style="text-shadow: 0px 0px 2px #000;"
        fade
        indicators
        :interval="5000"
        controls
        img-width="1024"
      >
        <b-carousel-slide
          v-for="(items, index) in swiperImg"
          :key="index"
          style="max-height:618px"
        >
          <template v-slot:img>
            <img
              class="d-block img-fluid w-100"
              style="cursor:pointer"
              width="1024"
              height="480"
              :src="items.src"
              @click="jump(items.link, items.txt)"
            />

            <div class="moredesc">
              <h2 style="padding-bottom:1rem">{{ items.txt }}</h2>
              <p class="pro-desc">{{ items.feature }}</p>
            </div>
          </template>
        </b-carousel-slide>
      </b-carousel>
    </div>

    <div v-if="classNow == 0" style="padding:20px 0">
      <b-row class="ProRow" v-for="(items, index) in newProImg" :key="index">
        <b-col
          class="proBox"
          v-for="(item, subindex) in items"
          :key="subindex"
          @click="jump(item.productId, item.productName)"
        >
          <div v-if="item.productClassification === '1'">
            <b-img
              fluid
              :src="item.productImg"
              class="ProductImg"
              ref="Imgs"
            ></b-img>
          </div>
          <div v-else>
            <b-img
              fluid
              :src="item.productImg"
              class="ProductImg234"
              ref="Imgs"
            ></b-img>
          </div>
          <div style="position:relative">
            <div class="Cardline"></div>
            <p
              class="productName"
              style="text-align:center;font-size:16px;font-family:Orbitron"
            >
              {{ item.productName }}
            </p>
          </div>
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <b-row
        class="ProRow"
        v-for="(items, index) in AfterClassifyImg"
        :key="index"
      >
        <b-col
          class="proBox"
          v-for="(item, subindex) in items"
          :key="subindex"
          @click="jump(item.productId, item.productName)"
        >
          <div v-if="item.productClassification === '1'">
            <b-img
              fluid
              :src="item.productImg"
              class="ProductImg"
              ref="Imgs"
            ></b-img>
          </div>
          <div v-else>
            <b-img
              fluid
              :src="item.productImg"
              class="ProductImg234"
              ref="Imgs"
            ></b-img>
          </div>
          <div class="Cardline"></div>
          <p class="productName" style="text-align:center;font-size:16px">
            {{ item.productName }}
          </p>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { postRequest } from "../../main";

export default {
  props: {
    g: {},
  },
  data() {
    return {
      picurl: "http://imgs.pioneertools.com",
      total: 0,
      temp: [],
      ishide: false,
      ProHeadImg: {
        src: require("../../../static/images/carousel_3.jpg"),
      },
      cur_page: 1,
      newProImg: [],
      AfterClassifyImg: [],
      Productimg: [],
      classifiedPro: [[], [], [], []],
      classNow: 0,
      swiperImg: [
        {
          src: require("../../../static/logoimg/AlTin.png"),
          txt: "超A系列",
          feature: "硬度高   耐高温  热硬性好  附着力强",
          link: 73,
        },
        {
          src: require("../../../static/logoimg/c3000.png"),
          txt: "新C3000",
          feature: "超硬  耐磨  锯切不锈钢",
          link: 74,
        },
        {
          src: require("../../../static/logoimg/Tin.png"),
          txt: "氮化钛涂层",
          feature: "提高耐热性  韧性  抗磨损性  抗粘着性 提高锯切速度 经济有效",
          link: 72,
        },
        {
          src: require("../../../static/logoimg/Vapo.png"),
          txt: "蒸汽涂层",
          feature: "增强锯片自润能力  增加锯片的使用寿命  锯切低抗拉强度",
          link: 71,
        },
      ],
      menuSize: "medium",
      menuOffsetY: -57,
    };
  },
  methods: {
    getData() {
      postRequest("http://houtai.pioneertools.com/public/getAllProduct", {
        page: this.cur_page,
      }).then((res) => {
        let data = res.data.data.list;
        this.temp = data;
        if (res.data.data.total > 10) {
          this.total = res.data.data.total;
          this.cur_page++;
        }

        this.predo();
      });
    },
    predo() {
      for (let i = 0; i < this.temp.length; i++) {
        this.temp[i].productImg =
          this.picurl +
          this.temp[i].productImg.replace("sxito/productImg", "piotoolsmin");
        // console.log(data[i].productImg)
      }
      this.Productimg = this.temp;
      let num = new Array(0, 0, 0, 0, 0);
      for (var i = 1; i <= 4; i++) {
        for (var j = 0; j < this.Productimg.length; j++) {
          if (i == this.Productimg[j].productClassification) {
            this.classifiedPro[i].push(this.Productimg[j]);
            num[i]++;
          }
        }
      }
      const result = [];
      for (let i = 0; i < this.Productimg.length; i += 4) {
        result.push(this.Productimg.slice(i, i + 4));
      }

      this.newProImg = result;
      console.log(this.newProImg);
    },

    jump(id, title) {
      this.$router.push({
        name: "prodetail",
        params: {
          id: id,
          title: title,
        },
      });
    },
    ClassMethod() {
      if (this.g) {
        this.classNow = this.g;
        this.ishide = true;
      }
      postRequest(
        "http://houtai.pioneertools.com/public/selectProductByClassification",
        {
          productClassification: this.classNow,
        }
      ).then((res) => {
        // console.log(res);
        let data = res.data.data;
        for (let i = 0; i < data.length; i++) {
          // data[i].productDescription = data[i].productDescription.substring(0,20)+"..."
          data[i].productImg =
            this.picurl +
            data[i].productImg.replace("sxito/productImg", "piotoolsmin");
        }

        const result = [];
        for (var i = 0; i < data.length; i += 4) {
          result.push(data.slice(i, i + 4));
        }
        // console.log(result)
        this.AfterClassifyImg = result;
      });
    },
    toClassAll() {
      this.classNow = 0;
      this.ishide = false;
    },
    toClass1() {
      this.classNow = 1;
      this.ishide = true;
      this.ClassMethod();
    },
    toClass2() {
      this.classNow = 2;
      this.ishide = true;
      this.ClassMethod();
    },
    toClass3() {
      this.classNow = 3;
      this.ishide = true;
      this.ClassMethod();
    },
    toClass4() {
      this.classNow = 4;
      this.ishide = true;
      this.ClassMethod();
    },
    justifyImg() {
      if (document.body.clientWidth < 500) {
        this.$refs.Imgs.style.Width = 153.5 + "px";
      } else {
        this.$refs.Imgs.style.width = 263.5 + "px";
      }
    },
    justifyMenuSize() {
      if (document.body.clientWidth < 900) {
        this.menuSize = "small";
        this.menuOffsetY = -36;
      }
    },
  },
  mounted() {
    this.justifyMenuSize();
  },
  created: function() {
    this.getData();
    this.g && this.ClassMethod();
    this.justifyImg();

    // console.log(this.Productimg)
  },
};
</script>

<style lang="scss">
@import url("../../assets/css/anim.css");
.menu-wrapper {
  text-align: center;
  .md-menu {
    margin: 5px 10px;
    padding: 10px 6px;
    border-radius: 12px;
    background: linear-gradient(145deg, #e6e6e6, #ffffff);
    box-shadow: 15px 6px 30px #d6d6d6, -15px -6px 30px #ffffff;
    .md-button {
      /* color: aliceblue; */
      font-size: 18px;
    }
  }
}
@media screen and (max-width: 900px) {
  .menu-wrapper {
    display: flex;
    overflow-x: scroll;
    .md-menu {
      margin: 5px 3px;
      padding: 0;
      border-radius: 12px;
      background: linear-gradient(145deg, #e6e6e6, #ffffff);
      box-shadow: 5px 3px 5px #d6d6d6, -5px -3px 5px #ffffff;
      .md-button {
        /* color: aliceblue; */
        font-size: 14px;
      }
    }
  }
}

.proBox {
  max-width: 277px !important;
  position: relative;
  margin: 4px;
  /* margin-left: 20px; */
  background: url("../../../static/images/proitembg2.jpg");
  background-position: center;
}
@media screen and (max-width: 1300px) {
  .proBox {
    max-width: 232.2px !important;
  }
}
.ProRow {
  padding-top: 10px;
}
.Cardline {
  border: 2px solid #666;
  width: 120px;

  margin: 4px auto;
}
.nav-link,
.nav-link a {
  color: #000;
}

.nav-item ul a {
  color: #000 !important;
}
.ivu-dropdown-rel a {
  color: #515a6e;
  font-size: 17px;
  font-weight: 600;
}
.ProductImg:hover {
  -webkit-transform: scale(1.2) rotate(30deg);
  -moz-transform: scale(1.2) rotate(30deg);
  -o-transform: scale(1.2) rotate(30deg);
  transform-origin: 50% 50%;
}
.ProductImg {
  width: 95%;
  padding-left: 5%;
  padding-top: 10px;
  -webkit-transition: all 1s;
  -moz-transition: all 1s;
  -o-transition: all 1s;
}
.ProductImg234 {
  width: 80%;
  padding-left: 20%;
  padding-top: 10px;
}
.carousel-item {
  background: #26272a;
  min-height: 500px;
}
@media (max-width: 768px) {
  .carousel-item {
    min-height: 300px;
  }
}
</style>
<style scoped>
@media (max-width: 768px) {
  .proBox {
    max-width: 179.5px !important;
  }
}

.hideSwiper {
  display: none;
}
.ivu-dropdown-item a {
  margin: 0;
  line-height: normal;
  /* padding: 7px 16px; */
  clear: both;
  color: #515a6e;
  font-size: 14px !important;
  white-space: nowrap;
  list-style: none;
  cursor: pointer;
  transition: background 0.2s ease-in-out;
}
.ivu-dropdown-item {
  margin: 0;
  line-height: normal;
  padding: 7px 16px;
  clear: both;
  color: #515a6e;
  font-size: 14px !important;
  white-space: nowrap;
  list-style: none;
  cursor: pointer;
  transition: background 0.2s ease-in-out;
}
.ProductImg {
  width: 95%;
  padding-left: 5%;
  padding-top: 10px;
  -webkit-transition: all 1s;
  -moz-transition: all 1s;
  -o-transition: all 1s;
}
.ProductImg234 {
  width: 80%;
  padding-left: 20%;
  padding-top: 10px;
}
.carousel-item {
  background: #26272a;
  min-height: 500px;
}
@media (max-width: 768px) {
  .carousel-item {
    min-height: 300px;
  }
}
.carousel-item img {
  padding-top: 10%;
  max-width: 100%;
  visibility: hidden;
  animation: bottom-top 1.5s 1s ease-out forwards;
}
.carousel-caption {
}
.moredesc {
  position: absolute;
  right: 15%;
  top: 1.75rem;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center;
}
@media (max-width: 768px) {
  .moredesc {
    top: 0.25rem;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .moredesc h2 {
    font-size: 1.75rem;
  }
  .moredesc .pro-desc {
    font-size: 14px;
  }
  .pro-main {
    min-height: 600px;
  }
}
@media (min-width: 768px) {
  .pro-main {
    min-height: 840px;
  }
}
.moredesc h2 {
  font-size: 2rem;
  visibility: hidden;
  animation: top-bottom 0.5s 2s linear forwards;
  font-family: "Open Sans", "PingFang SC", "Microsoft YaHei", "Helvetica Neue",
    "Hiragino Sans GB", "WenQuanYi Micro Hei", Arial, sans-serif;
}
.moredesc .pro-desc {
  font-size: 18px;

  color: #999;
  font-weight: 600;
  visibility: hidden;
  animation: bottom-top 0.5s 2.5s linear forwards;
}
</style>
